import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const PageIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M13.5671 2.25C13.5671 1.83594 13.2311 1.50025 12.8171 1.5H3.18333C2.76912 1.5 2.43333 1.83579 2.43333 2.25V13.75C2.43333 14.1642 2.76912 14.5 3.18333 14.5H12.8171C13.2311 14.4998 13.5671 14.1641 13.5671 13.75V2.25ZM14.5671 13.75C14.5671 14.7163 13.7834 15.4998 12.8171 15.5H3.18333C2.21684 15.5 1.43333 14.7165 1.43333 13.75V2.25C1.43333 1.2835 2.21684 0.5 3.18333 0.5H12.8171C13.7834 0.500246 14.5671 1.28365 14.5671 2.25V13.75Z"
      fill="currentColor"
    />
    <path
      d="M11.2665 3.29999C11.5427 3.29999 11.7665 3.52385 11.7665 3.79999C11.7665 4.07613 11.5427 4.29999 11.2665 4.29999H4.73333C4.45719 4.29999 4.23333 4.07613 4.23333 3.79999C4.23333 3.52385 4.45719 3.29999 4.73333 3.29999H11.2665Z"
      fill="currentColor"
    />
    <path
      d="M11.2665 6.10001C11.5427 6.10001 11.7665 6.32386 11.7665 6.60001C11.7665 6.87615 11.5427 7.10001 11.2665 7.10001H4.73333C4.45719 7.10001 4.23333 6.87615 4.23333 6.60001C4.23333 6.32386 4.45719 6.10001 4.73333 6.10001H11.2665Z"
      fill="currentColor"
    />
    <path
      d="M11.2665 8.89999C11.5427 8.89999 11.7665 9.12385 11.7665 9.39999C11.7665 9.67614 11.5427 9.89999 11.2665 9.89999H4.73333C4.45719 9.89999 4.23333 9.67614 4.23333 9.39999C4.23333 9.12385 4.45719 8.89999 4.73333 8.89999H11.2665Z"
      fill="currentColor"
    />
    <path
      d="M7.53314 11.7C7.80928 11.7 8.03314 11.9239 8.03314 12.2C8.03314 12.4762 7.80928 12.7 7.53314 12.7H4.73333C4.45719 12.7 4.23333 12.4762 4.23333 12.2C4.23333 11.9239 4.45719 11.7 4.73333 11.7H7.53314Z"
      fill="currentColor"
    />
  </svg>
);
